module.exports = __webpack_public_path__ + "static/media/caminhao_sol.960ae55e.jpg";